import { createSelector } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import type { Token } from '../@types/Token';
import type { RootState } from '../reducers';

export const isAuthenticated = createSelector(
  (state: RootState) => state.auth.token,
  (token) => {
    if (token && process.env.SSR && process.env.NODE_ENV === 'testing') return true;

    if (token) {
      const data = jwtDecode<Token>(token);
      const expires = new Date(data.exp * 1000);

      if (expires > new Date()) {
        return true;
      }
    }

    return false;
  },
);

export const getTokenId = createSelector(
  (state: RootState) => state.auth.token,
  (token) => {
    if (!token) return null;
    return jwtDecode<Token>(token).sub;
  },
);

export const getToken = (state: RootState) => state.auth.token;

export const getResponseStatus = (state: RootState) => state.auth.requestStatus;
